/**
 * integrationsSeed — seeds for INT-1 (Integration Hub foundation).
 * Two demo connectors for kairos-demo: one ERP stub, one TMS stub.
 * Also seeds a handful of sync logs and field maps so the hub looks real.
 */

const now = Date.now();
const minsAgo = (m) => new Date(now - m * 60000).toISOString();
const hoursAgo = (h) => new Date(now - h * 3600000).toISOString();

export const SEED_CONNECTORS = [
  {
    id: 'conn-demo-infor-csd',
    connectorType: 'infor_csd',
    label: 'Keyston Bros — Infor CloudSuite Distribution',
    subtitle: 'API-First Connector',
    category: 'erp',
    status: 'connected',
    health: 'green',
    syncIntervalMinutes: 15,
    mockMode: true,
    lastSyncAt: minsAgo(7),
    lastHealthCheckAt: minsAgo(3),
    lastError: null,
    syncScope: ['Item Master', 'Customer Master', 'Inventory Positions', 'POs'],
    implementationNote: 'Typical implementation: 4–6 weeks, runs parallel to go-live',
    config: {
      apiBase: 'https://api.inforcloudsuite.com/demo',
      authType: 'Infor OAuth 2.0',
      tenantRef: 'keyston-bros',
      warehouse: 'DEN',
    },
    icon: '🏭',
  },
  {
    id: 'conn-demo-mcleod',
    connectorType: 'mcleod',
    label: 'Legacy TMS — McLeod LoadMaster (Read-Only)',
    category: 'tms',
    status: 'connected',
    health: 'green',
    syncIntervalMinutes: 15,
    mockMode: true,
    lastSyncAt: minsAgo(11),
    lastHealthCheckAt: minsAgo(4),
    lastError: null,
    config: {
      apiBase: 'https://mcleodapi.demo',
      authType: 'api_key',
      companyCode: 'WCHMN',
    },
    icon: '🚛',
  },
];

export const SEED_CONNECTOR_SYNC_LOGS = [
  { id: 'sync-001', connectorId: 'conn-demo-infor-csd', direction: 'inbound', recordsIn: 12, recordsOut: 0, errors: 0, durationMs: 842, status: 'success', summary: 'Item master sync — 12 items updated', ranAt: minsAgo(7) },
  { id: 'sync-002', connectorId: 'conn-demo-infor-csd', direction: 'outbound', recordsIn: 0, recordsOut: 3, errors: 0, durationMs: 611, status: 'success', summary: 'PO writeback — 3 replenishment POs created', ranAt: minsAgo(22) },
  { id: 'sync-003', connectorId: 'conn-demo-infor-csd', direction: 'inbound', recordsIn: 14, recordsOut: 0, errors: 0, durationMs: 730, status: 'success', summary: 'Item master sync', ranAt: hoursAgo(1) },
  { id: 'sync-004', connectorId: 'conn-demo-infor-csd', direction: 'inbound', recordsIn: 9, recordsOut: 0, errors: 1, durationMs: 1204, status: 'partial', summary: 'Item master sync — 1 field-map mismatch on UOM', ranAt: hoursAgo(3) },
  { id: 'sync-005', connectorId: 'conn-demo-mcleod', direction: 'inbound', recordsIn: 5, recordsOut: 0, errors: 0, durationMs: 402, status: 'success', summary: 'Loads imported → AEGIS overlay applied to 5 loads', ranAt: minsAgo(11) },
  { id: 'sync-006', connectorId: 'conn-demo-mcleod', direction: 'inbound', recordsIn: 8, recordsOut: 0, errors: 0, durationMs: 511, status: 'success', summary: 'Loads imported', ranAt: minsAgo(26) },
  { id: 'sync-007', connectorId: 'conn-demo-mcleod', direction: 'inbound', recordsIn: 11, recordsOut: 0, errors: 0, durationMs: 494, status: 'success', summary: 'Loads imported', ranAt: hoursAgo(2) },
];

export const SEED_CONNECTOR_FIELD_MAPS = [
  { id: 'map-001', connectorId: 'conn-demo-infor-csd', sourceField: 'ITEM_NUMBER', kairosField: 'items.sku', transform: 'trim', confidence: 0.95, suggestedBy: 'aegis' },
  { id: 'map-002', connectorId: 'conn-demo-infor-csd', sourceField: 'ITEM_DESC', kairosField: 'items.description', transform: null, confidence: 0.9, suggestedBy: 'aegis' },
  { id: 'map-003', connectorId: 'conn-demo-infor-csd', sourceField: 'UOM_BASE', kairosField: 'items.uomBase', transform: 'upper', confidence: 0.92, suggestedBy: 'aegis' },
  { id: 'map-004', connectorId: 'conn-demo-infor-csd', sourceField: 'PACK_SIZE', kairosField: 'items.packSize', transform: null, confidence: 0.88, suggestedBy: 'aegis' },
  { id: 'map-005', connectorId: 'conn-demo-infor-csd', sourceField: 'REORDER_POINT', kairosField: 'items.reorderPoint', transform: null, confidence: 0.9, suggestedBy: 'aegis' },
  { id: 'map-006', connectorId: 'conn-demo-mcleod', sourceField: 'ORDER_NO', kairosField: 'loads.referenceNumber', transform: 'trim', confidence: 0.87, suggestedBy: 'aegis' },
  { id: 'map-007', connectorId: 'conn-demo-mcleod', sourceField: 'BILL_TO_NAME', kairosField: 'customers.name', transform: null, confidence: 0.82, suggestedBy: 'aegis' },
  { id: 'map-008', connectorId: 'conn-demo-mcleod', sourceField: 'PICKUP_DT', kairosField: 'loads.pickupAt', transform: null, confidence: 0.9, suggestedBy: 'aegis' },
  { id: 'map-009', connectorId: 'conn-demo-mcleod', sourceField: 'DELIVERY_DT', kairosField: 'loads.deliveryAt', transform: null, confidence: 0.9, suggestedBy: 'aegis' },
];
